<template>
  <!-- Error page-->
  <div class="misc-wrapper">
    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center" >
        <div v-if="hasError">
          <h2 class="mb-1">
            Erreur, {{ errorTitle }}
          </h2>
          <p class="mb-2">
            {{ errorMessage }}
            Si vous pensez que c’est une erreur, contactez l’émetteur.

          </p>
          <b-button
              variant="primary"
              class="mb-2 btn-sm-block"
              :to="{path:'/'}"
          >
            Revenir à l'accueil
          </b-button>
        </div>
        <div v-else>
          <h2 class="mb-1">
            Vérification terminée, vous allez être redirigé ...
          </h2>
        </div>


        <!-- image -->
        <b-img
            fluid
            :src="imgUrl"
            alt="Error page"
        />
      </div>
    </div>
  </div>
  <!-- / Error page-->
</template>

<script>
import axios from '@axios';
import {BButton, BImg} from "bootstrap-vue";
import store from "@/store";

export default {
  name: 'Pay',
  components: {BButton, BImg},
  data() {
    return {
      downImg: require('@/assets/images/pages/error.svg'),
      hasError: false,
      errorTitle: '',
      errorMessage: '',
    };
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.downImg = require('@/assets/images/pages/error-dark.svg')
        return this.downImg
      }
      return this.downImg
    },
  },
  mounted() {
    this.pingServer();
  },
  methods: {
    async pingServer() {
      const id = this.$route.params.id;
      axios.get(`/document-templates/${id}/pay`).then(({ data }) => {
        console.log("=== res vs ===");
        console.log(data["hydra:member"]);
        const signatureLink = data["hydra:member"][0].signPosition
            ? data["hydra:member"].find(e => e.signPosition == 1).link
            : data["hydra:member"][0].link;
        console.log("signatureLink -> ", signatureLink);
        window.parent.postMessage({ type: "stancer_redirect", url: signatureLink }, "*");
        window.location.href = signatureLink;

      }).catch(error => {
        this.hasError = true;
        if (error.response && error.response.status === 404) {
          this.errorTitle = 'Paiement introuvable';
          this.errorMessage = 'Aucun paiement correspondant n’a été trouvé.';
        } else {
          this.errorTitle = 'Le paiement a échoué';
          this.errorMessage = 'Nous n’avons pas pu confirmer le paiement !';
        }
      });
    },
  },
};
</script>
<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';
</style>
<style scoped>
.pay-container {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-height: 80vh;
  flex-direction: column;
  padding: 20px;
}

.error-message h1 {
  color: red;
}

button {
  margin: 20px;
  padding: 10px 20px;
  font-size: 16px;
}

.contact a {
  color: blue;
  text-decoration: underline;
}
</style>
